const getPageText = (pagePath: string) => {
  switch (pagePath) {
    case "sobre-nos":
      return "Sobre Nós";
    case "pessoas":
      return "Pessoas";
    case "docs-politicas":
      return "Políticas";
    case "midia":
      return "Mídia";
    case "telecom":
      return "Telecom";
    case "energia":
      return "Energia";
    default:
      return "";
  }
}
export { getPageText };
